import { jsxs, jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { token } from "./token.js";
import { baseStyles } from "./BaseStyles.js";
function Baloon(props) {
  return /* @__PURE__ */ jsxs(BaloonStyled, {
    role: "status",
    "aria-live": "polite",
    children: [props.thumbnail && /* @__PURE__ */ jsx(ThumbnailWrapper, {
      children: props.thumbnail
    }), /* @__PURE__ */ jsxs(Text, {
      children: [/* @__PURE__ */ jsx(Title, {
        title: typeof props.title === "string" ? props.title : "",
        children: props.title
      }), props.description && /* @__PURE__ */ jsx(Description, {
        title: typeof props.description === "string" ? props.description : "",
        children: props.description
      })]
    }), /* @__PURE__ */ jsx(Action, {
      children: props.button
    }), typeof props.progressPercentage === "number" && /* @__PURE__ */ jsx(Progress, {
      style: {
        width: props.progressPercentage + "%"
      }
    })]
  });
}
const BaloonStyled = styled.div.withConfig({
  displayName: "BaloonStyled",
  componentId: "sc-1yjr5hd-0"
})(["", ";position:relative;display:flex;align-items:flex-start;overflow:hidden;box-sizing:border-box;width:480px;padding:", ";border-radius:", ";background:", ";box-shadow:", ",", ";"], baseStyles, token.spacing5, token.radiusLarge, token.white, token.elevationStatic, token.elevation2);
const ThumbnailWrapper = styled.div.withConfig({
  displayName: "ThumbnailWrapper",
  componentId: "sc-1yjr5hd-1"
})(["flex:none;margin-right:", ";"], token.spacing5);
const Text = styled.div.withConfig({
  displayName: "Text",
  componentId: "sc-1yjr5hd-2"
})(["flex:1;align-self:center;"]);
const Title = styled.h2.withConfig({
  displayName: "Title",
  componentId: "sc-1yjr5hd-3"
})(["display:-webkit-box;overflow:hidden;margin:0;font:inherit;-webkit-line-clamp:3;-webkit-box-orient:vertical;"]);
const Description = styled.p.withConfig({
  displayName: "Description",
  componentId: "sc-1yjr5hd-4"
})(["display:-webkit-box;overflow:hidden;margin:", " 0 0;color:", ";font-size:", ";line-height:20px;-webkit-line-clamp:4;-webkit-box-orient:vertical;"], token.spacing2, token.colorTextMuted, token.fontSize75);
const Action = styled.div.withConfig({
  displayName: "Action",
  componentId: "sc-1yjr5hd-5"
})(["flex:none;"]);
const Progress = styled.div.withConfig({
  displayName: "Progress",
  componentId: "sc-1yjr5hd-6"
})(["position:absolute;bottom:0;left:0;height:4px;background-color:", ";transition:width 0.2s;"], token.brandPrimary500);
export {
  Baloon
};
//# sourceMappingURL=Baloon.js.map
